<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-menu-button color="light"></ion-menu-button>
        </ion-buttons>
        <ion-buttons slot="end"  >
          <img src="@/assets/logo.png" width="130" alt="logo">
        </ion-buttons>
        <ion-title>{{ store.view }}</ion-title>
      </ion-toolbar>
    </ion-header>

    <ion-tabs>
      
      <ion-router-outlet></ion-router-outlet>

      <ion-tab-bar slot="bottom"  mode="ios">
        <ion-tab-button tab="tab1" href="/tabs/explotacion" >
          <ion-icon :icon="informationCircleOutline"/>
          <ion-label>Info</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="tab2" href="/tabs/actas" >
          <ion-icon :icon="readerOutline" />
          <ion-label>Actas</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="tab5" href="/explotaciones" >
          <ion-icon :icon="homeOutline" />
          <ion-label>Inicio</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="tab3" href="/tabs/informes/list" >
          <ion-icon  :icon="documentsOutline" />
          <ion-label>Informes</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="tab4" href="/tabs/lotes" >
          <ion-icon  :icon="eyeOutline" />
          <ion-label>Lotes</ion-label>
        </ion-tab-button>
      </ion-tab-bar>
    </ion-tabs>
  </ion-page>
</template>

<script setup lang="ts">
import { 
  IonButtons,
  IonButton,
  IonMenuButton,
  IonBackButton,
  IonHeader,
  IonTitle,
  IonToolbar, 
  IonTabBar, 
  IonTabButton, 
  IonTabs, 
  IonLabel, 
  IonIcon, 
  IonPage, 
  IonRouterOutlet 
} from '@ionic/vue';
import { 
  informationCircleOutline, 
  readerOutline, 
  documentsOutline, 
  eyeOutline, 
  homeOutline
} from 'ionicons/icons';
import  { useUserStore }  from '@/stores/store.user';

const store = useUserStore();
</script> 
